import React, { useCallback } from "react";
import { Checkmark } from "bb.lego-ui";
import PropTypes from "prop-types";
import Links from "common/constants/Links";
import { to2DecimalPriceString } from "common/utils/NumberFormatter";
import { getTimePeriod } from "common/utils/subscriptionCopyHelpers";
import OfferDetails from "./OfferDetails";
import { getDate } from "common/utils/dateUtil";
import styles from "./styles.module.scss";

const SuccessScreen = ({
    allOffers,
    selectedOffer,
    nextRenewalDate,
    bloombergSiteUrl
}) => {
    const { pricing } = allOffers[selectedOffer];
    const { totalDiscount, discountPeriod } = pricing;
    const discount = to2DecimalPriceString(totalDiscount);
    const startDate = getDate(nextRenewalDate);

    const focusOnButton = useCallback((node) => {
        node && node.focus();
    }, []);

    return (
        <>
            <div className={ styles.successContainer }>
                <Checkmark color="green" size="large" />
                <h2 className={ styles.successTitle }>Thank you!</h2>
                <p className={ styles.successText }>
                    You will save { discount } on your subscription over the next {
                        getTimePeriod(discountPeriod).toLowerCase()
                    }. Congrats!
                </p>
            </div>
            <OfferDetails pricing={ pricing } startDate={ startDate } />
            <a className={ styles.homepageLink } href={ bloombergSiteUrl } ref={ focusOnButton }>
                Take me back to bloomberg.com
            </a>
            <div className={ styles.contactSupport }>
                Need help with your subscription?&nbsp;
                <a className={ styles.contactLink } href={ Links.TERMINAL_CONTACT_US } target="_blank">
                    Contact Customer Support
                </a>.
            </div>
        </>
    );
};

SuccessScreen.propTypes = {
    allOffers: PropTypes.array.isRequired,
    setSelectedOffer: PropTypes.func.isRequired,
    nextRenewalDate: PropTypes.string.isRequired,
    bloombergSiteUrl: PropTypes.string.isRequired
};

export default SuccessScreen;
